import React from 'react';
import c from 'classnames';
import Immutable from 'immutable';

import { Paragraph } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import { Container } from '@uncinc/uncinc-react-kitchen-sink';

import { NodeHomepage as Type } from '../../../types/uncinc_profile/nodes';
import { HomepageHero } from '../../../components';
import { DEFAULT_LANGUAGE } from '../../../config/constants';

export interface NodeHomepageProps {
  entity: ImmutableEntity<Type>;
  className?: string;
}

const NodeHomepage: React.FC<NodeHomepageProps> = ({ entity, className }) => {
  const classNames = c(className, 'NodeHomepage');
  const node = entity.toJS();

  const title = node.title[0].value;
  const body = node.body[0]?.processed;
  const paragraphs = node.field_paragraphs;

  return (
    <article itemType="http://schema.org/WebPage" className={classNames}>
      <HomepageHero title={title} body={body} />

      {paragraphs.length > 0 && (
        <div className="content-section">
          <Container>
            <div className="NodeHomepage__paragraphs">
              {paragraphs.map((paragraph) => {
                const id = paragraph.target_id;
                const language = paragraph.entity?.langcode[0].value || DEFAULT_LANGUAGE;

                return (
                  <Paragraph
                    key={`paragraph:${id}:${language}`}
                    id={id}
                    entity={Immutable.fromJS(paragraph.entity)}
                  />
                );
              })}
            </div>
          </Container>
        </div>
      )}
    </article>
  );
};

export default NodeHomepage;
